import React from 'react';

import AddIcon from 'icons/add.svg';
import { useTranslation } from 'react-i18next';

import OutlinedButton from 'components/application/buttons/OutlinedButton';
import RowBar from 'components/application/RowBar';
import SearchField from 'components/application/SearchField';

export default function SubcontractorsBar({
  isActionButtonVisible,
  onNewSubcontractor,
  onSearchInputChange,
  onSearchReset,
  subcontractorsCount,
  subcontractorsSearch,
}) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'subcontractors.SubcontractorsBar',
  });

  const { t: i18nTSubcontractors } = useTranslation('common', {
    keyPrefix: 'subcontractors',
  });

  return (
    <RowBar
      actions={
        isActionButtonVisible && (
          <OutlinedButton color='grey' onClick={onNewSubcontractor} size='sm'>
            <AddIcon className='-tw-ml-2' height={24} width={24} />
            <span>{i18nTSubcontractors('addNewSubContractor')}</span>
          </OutlinedButton>
        )
      }
      content={
        subcontractorsCount > 0 && (
          <SearchField
            additionalClasses='search-field__lg'
            name='subcontractorsSearch'
            onChange={onSearchInputChange}
            onReset={onSearchReset}
            placeholder={i18nT('search.placeholder')}
            value={subcontractorsSearch}
          />
        )
      }
      modifiers={[
        'border-top-curved',
        'border-bottom-none',
        'flex-align-items-ie-fix',
      ]}
    />
  );
}
